import OrderAdjustRuleList from './view';


const OrderAdjustRulePage = {
    name: 'OrderAdjustRule',
    list: OrderAdjustRuleList,
};

export default OrderAdjustRulePage;